<template>
    <v-app>
        <AppBar />

        <v-main>
            <router-view />
        </v-main>

        <Snackbars />
    </v-app>
</template>

<script lang="ts">
import Vue from 'vue'
import Component from 'vue-class-component'
import AppBar from '@/components/app-bar/AppBar.vue'
import Snackbars from '@/components/Snackbars.vue'

@Component({
    components: {Snackbars, AppBar},
})
export default class App extends Vue
{
}
</script>
